import { STORAGE_KEYS } from 'app/constants/storage.constant';

export type ViewMode = 'mobile' | 'full';

export const MOBILE_MAX_WIDTH = 1280;

const isViewMode = (value: unknown): value is ViewMode => value === 'mobile' || value === 'full';

export const resolveViewMode = (stored: ViewMode | null, width: number): ViewMode =>
  stored ?? (width < MOBILE_MAX_WIDTH ? 'mobile' : 'full');

// localStorage can throw (private mode, blocked storage): fall back to the width default.
export const readViewModePreference = (): ViewMode | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.VIEW_MODE);
    return isViewMode(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const writeViewModePreference = (mode: ViewMode): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.VIEW_MODE, mode);
  } catch {
    // The switch still works for this session through navigation; only persistence is lost.
  }
};

// Evaluated on load / navigation to `/` only. No resize listener: rotating a tablet must not switch versions.
export const currentViewMode = (): ViewMode => resolveViewMode(readViewModePreference(), window.innerWidth);
